'use strict';
import classNames from 'classnames';
import isFunction from 'lodash/isFunction';
import * as T from 'prop-types';
import React, {PureComponent} from 'react';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {getItemClass} from '../../../core-utilities/redux/utils';
import {CommentIndicatorComponent} from '../CommentIndicator/CommentIndicatorComponent';
import {UserChannelItemView} from './UserChannelItemView';


export class UserChannelItemComponent extends PureComponent {
  static propTypes = {
    className: T.string,
    chatId: T.string,
    collection: T.string,
    latestReceived: T.any, /* Must be Date or number */
    onClick: T.func,
    onContextMenu: T.func,
    tagName: T.string,
    name: T.string,
    latestMessage: T.string,
    parentName: T.string,

    init: T.bool,
  };

  static defaultProps = {
    init: true,
  };

  static commentIndicatorClassName = UserChannelItemView.commentIndicatorClassName;

  constructor(props) {
    super(props);
    this.state = {
      hasUnread: false,
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleContextMenu = this.handleContextMenu.bind(this);
    this.handleHasUnread = this.handleHasUnread.bind(this);
  }

  handleClick(e) {
    if (isFunction(this.props.onClick)) {
      this.props.onClick(e, this.props.model);
    }
  }

  handleContextMenu(e) {
    if (isFunction(this.props.onContextMenu)) {
      this.props.onContextMenu(e, {id: this.props.chatId, collection: this.props.collection, name: this.props.name});
    }
  }

  handleHasUnread(chatId, hasUnread) {
    this.setState({
      hasUnread,
    });
  }

  render() {
    const model = this.props.model;
    return (
      <UserChannelItemView
        {...this.props}
        className={classNames(this.props.className, getItemClass(model))}
        hasUnread={this.state.hasUnread}
        onClick={this.handleClick}
        onContextMenu={this.handleContextMenu}
      >
        <CommentIndicatorComponent
          className={UserChannelItemComponent.commentIndicatorClassName}
          key={model.id}
          userId={this.props.userId}
          chatId={getId(model)}
          collection={UserChannelItemComponent.getTarget(model)}
          allowNav={this.props.allowNav}
          onHasUnread={this.handleHasUnread}
          onAccessError={this.props.onAccessError}
          onClick={this.handleClick}

          init={this.props.init}
        />
      </UserChannelItemView>
    );
  }

  static getTarget(model) {
    return model.target ? model.target.collection : null;
  }
}



// WEBPACK FOOTER //
// ./src/js/comments/components/UserChannelItem/UserChannelItemComponent.js